// extracted by mini-css-extract-plugin
module.exports = {"transition":"transition--3m-61"};